import { render } from "./table2.vue?vue&type=template&id=0caaebca&scoped=true"
import script from "./table2.vue?vue&type=script&lang=js"
export * from "./table2.vue?vue&type=script&lang=js"

import "./table2.vue?vue&type=style&index=0&id=0caaebca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0caaebca"

export default script